/* WF back-in-stock (Klaviyo native Back in Stock). Replaces Kbite. 2026-10-21 */
(function () {
  if (window.__wfBisLoaded) return;
  window.__wfBisLoaded = true;

  var COMPANY_ID = 'SKKcKm';
  var LIST_ID = 'WJjvp8';
  var HEADERS = { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' };
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var TXT = {
    heading: "Woof! You'll be the first to know",
    sub: "Leave your email and we'll tell you the moment it's back in stock.",
    placeholder: 'Your email',
    button: 'Notify me',
    sending: 'Sending...',
    marketing: 'Also send me new gear, exclusive offers and all things dog.',
    privacy: 'We never share your email.',
    success: 'Got it! You and your pup are on the list.',
    done: 'All set!',
    invalid: "That doesn't look right. Mind checking your email?",
    error: 'Something went wrong. Please try again or message us.',
    close: 'Close',
    sticky: 'Notify me',
    alt: "Want a sold-out one? Get notified when it's back.",
    pick: 'Which one?'
  };

  var lastVariant = {}; // sectionId -> variant object from PUB_SUB
  var dialog = null;
  var current = null; // { variantId, title, variantTitle }
  var opener = null;

  function roots() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-wf-bis]'));
  }

  function readMap(root) {
    if (root.__wfMap) return root.__wfMap;
    var map = {};
    try {
      var el = root.querySelector('[data-wf-bis-map]');
      map = JSON.parse(el ? el.textContent : '{}') || {};
    } catch (e) { map = {}; }
    root.__wfMap = map;
    return map;
  }

  function currentVariantId(root) {
    var form = document.getElementById(root.dataset.form);
    var input = form && form.querySelector('input[name="id"]');
    var id = input && input.value ? String(input.value) : '';
    var lv = lastVariant[root.dataset.section];
    if (!id && lv && lv.id) id = String(lv.id);
    return id;
  }

  function stateFor(root) {
    var id = currentVariantId(root);
    if (!id) return null;
    var map = readMap(root);
    var lv = lastVariant[root.dataset.section];
    var available = map[id] ? map[id][0] : null;
    if (lv && String(lv.id) === id && typeof lv.available === 'boolean') available = lv.available;
    var vTitle = map[id] ? map[id][1] : (lv && String(lv.id) === id ? lv.title : '');
    if (vTitle === 'Default Title') vTitle = '';
    return { variantId: id, available: available, title: root.dataset.title || '', variantTitle: vTitle || '' };
  }

  function soldOutList(root) {
    var map = readMap(root);
    return Object.keys(map).filter(function (k) { return map[k] && map[k][0] === false; })
      .map(function (k) { return { id: k, title: map[k][1] || '' }; });
  }

  function stickyButtons(root) {
    var form = document.getElementById(root.dataset.form + '--alt');
    if (!form) return null;
    return form.querySelector('.product-form__buttons') || form;
  }

  function ensureStickyLink(root) {
    var wrap = stickyButtons(root);
    if (!wrap) return null;
    var link = wrap.querySelector('.wf-bis-open');
    if (!link) {
      link = document.createElement('button');
      link.type = 'button';
      link.className = 'wf-bis-open';
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('data-wf-bis-section', root.dataset.section);
      link.textContent = TXT.sticky;
      link.hidden = true;
      wrap.appendChild(link);
    }
    return link;
  }

  function sync() {
    roots().forEach(function (root) {
      var st = stateFor(root);
      var show = !!(st && st.available === false);
      var btn = root.querySelector('.wf-bis-btn');
      if (btn && btn.hidden === show) btn.hidden = !show;
      var link = ensureStickyLink(root);
      if (link && link.hidden === show) link.hidden = !show;
      var alt = root.querySelector('.wf-bis-alt');
      if (alt) {
        var showAlt = !show && soldOutList(root).length > 0;
        if (alt.hidden === showAlt) alt.hidden = !showAlt;
      }
    });
  }

  var syncTimer = null;
  function queueSync() {
    if (syncTimer) return;
    syncTimer = setTimeout(function () { syncTimer = null; sync(); }, 60);
  }

  /* ---------- popup ---------- */
  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    if (text != null) n.textContent = text;
    return n;
  }

  function buildDialog() {
    if (dialog) return dialog;
    dialog = el('dialog', { class: 'wf-bis wf-bis-dialog', 'aria-labelledby': 'WfBisTitle', 'aria-describedby': 'WfBisSub' });
    var box = el('div', { class: 'wf-bis-box' });
    var close = el('button', { type: 'button', class: 'wf-bis-close', 'aria-label': TXT.close });
    close.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    var bar = el('span', { class: 'wf-bis-bar', 'aria-hidden': 'true' });
    var h = el('h2', { class: 'wf-bis-title', id: 'WfBisTitle' }, TXT.heading);
    var sub = el('p', { class: 'wf-bis-sub', id: 'WfBisSub' }, TXT.sub);
    var prod = el('div', { class: 'wf-bis-product' });
    prod.appendChild(el('span', { class: 'wf-bis-product-title' }));
    prod.appendChild(el('span', { class: 'wf-bis-variant-title' }));
    var pickWrap = el('div', { class: 'wf-bis-pick', hidden: 'hidden' });
    pickWrap.appendChild(el('label', { for: 'WfBisPick', class: 'wf-bis-pick-label' }, TXT.pick));
    var pick = el('select', { id: 'WfBisPick', class: 'wf-bis-select', name: 'wf_bis_variant' });
    pickWrap.appendChild(pick);
    pick.addEventListener('change', function () { if (current) current.variantId = pick.value; });

    var form = el('form', { class: 'wf-bis-form', novalidate: 'novalidate' });
    var label = el('label', { for: 'WfBisEmail', class: 'wf-bis-vh' }, 'Email');
    var input = el('input', { id: 'WfBisEmail', class: 'wf-bis-email', type: 'email', name: 'wf_bis_email', autocomplete: 'email', inputmode: 'email', placeholder: TXT.placeholder, 'aria-describedby': 'WfBisMsg' });
    var msg = el('p', { id: 'WfBisMsg', class: 'wf-bis-msg', role: 'alert', 'aria-live': 'polite' });
    var submit = el('button', { type: 'submit', class: 'wf-bis-submit' }, TXT.button);
    var mk = el('label', { class: 'wf-bis-mk' });
    var cb = el('input', { type: 'checkbox', class: 'wf-bis-mk-input', name: 'wf_bis_marketing' });
    cb.checked = true;
    mk.appendChild(cb);
    mk.appendChild(el('span', { class: 'wf-bis-mk-label' }, TXT.marketing));
    var privacy = el('p', { class: 'wf-bis-privacy' }, TXT.privacy);
    form.appendChild(label);
    form.appendChild(input);
    form.appendChild(msg);
    form.appendChild(submit);
    form.appendChild(mk);
    form.appendChild(privacy);

    var ok = el('div', { class: 'wf-bis-success', hidden: 'hidden' });
    ok.appendChild(el('p', { class: 'wf-bis-success-msg', role: 'status' }, TXT.success));
    var done = el('button', { type: 'button', class: 'wf-bis-done' }, TXT.done);
    ok.appendChild(done);

    box.appendChild(close);
    box.appendChild(bar);
    box.appendChild(h);
    box.appendChild(sub);
    box.appendChild(prod);
    box.appendChild(pickWrap);
    box.appendChild(form);
    box.appendChild(ok);
    dialog.appendChild(box);
    document.body.appendChild(dialog);

    close.addEventListener('click', closeDialog);
    done.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) closeDialog(); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); closeDialog(); });
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('wf-bis-lock'); });
    dialog.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && !dialog.showModal) closeDialog();
    });
    input.addEventListener('input', function () {
      if (msg.textContent && EMAIL_RE.test(input.value.trim())) { msg.textContent = ''; input.removeAttribute('aria-invalid'); }
    });
    form.addEventListener('submit', onSubmit);
    return dialog;
  }

  function openDialog(state, trigger, root) {
    if (!state) return;
    buildDialog();
    current = { variantId: state.variantId, title: state.title, variantTitle: state.variantTitle };
    opener = trigger || document.activeElement;
    dialog.querySelector('.wf-bis-product-title').textContent = state.title;
    var vt = dialog.querySelector('.wf-bis-variant-title');
    var pickWrap = dialog.querySelector('.wf-bis-pick');
    var pick = dialog.querySelector('.wf-bis-select');
    var list = root ? soldOutList(root) : [];
    var usePick = list.length > 1 || (state.available !== false && list.length > 0);
    pick.innerHTML = '';
    if (usePick) {
      var inList = false;
      list.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title || state.title;
        if (v.id === state.variantId) { o.selected = true; inList = true; }
        pick.appendChild(o);
      });
      if (!inList) pick.selectedIndex = 0;
      current.variantId = pick.value;
    }
    pickWrap.hidden = !usePick;
    vt.textContent = state.variantTitle;
    vt.hidden = usePick || !state.variantTitle;
    var form = dialog.querySelector('.wf-bis-form');
    var ok = dialog.querySelector('.wf-bis-success');
    var msg = dialog.querySelector('.wf-bis-msg');
    var submit = dialog.querySelector('.wf-bis-submit');
    form.hidden = false;
    ok.hidden = true;
    msg.textContent = '';
    msg.classList.remove('is-error');
    submit.disabled = false;
    submit.textContent = TXT.button;
    dialog.querySelector('.wf-bis-email').removeAttribute('aria-invalid');
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.classList.add('wf-bis-fallback');
    }
    document.documentElement.classList.add('wf-bis-lock');
    setTimeout(function () { dialog.querySelector('.wf-bis-email').focus(); }, 30);
  }

  function closeDialog() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    document.documentElement.classList.remove('wf-bis-lock');
    if (opener && typeof opener.focus === 'function' && document.contains(opener)) opener.focus();
  }

  function post(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + COMPANY_ID, {
      method: 'POST',
      headers: HEADERS,
      body: JSON.stringify(body)
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    var input = dialog.querySelector('.wf-bis-email');
    var msg = dialog.querySelector('.wf-bis-msg');
    var submit = dialog.querySelector('.wf-bis-submit');
    var cb = dialog.querySelector('.wf-bis-mk-input');
    var email = input.value.trim();
    if (!EMAIL_RE.test(email)) {
      msg.textContent = TXT.invalid;
      msg.classList.add('is-error');
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    if (!current || !current.variantId) {
      msg.textContent = TXT.error;
      msg.classList.add('is-error');
      return;
    }
    msg.textContent = '';
    submit.disabled = true;
    submit.textContent = TXT.sending;

    var bis = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + current.variantId } }
        }
      }
    };

    post('back-in-stock-subscriptions', bis)
      .then(function (res) {
        if (!res.ok) throw new Error('bis ' + res.status);
        if (!cb.checked) return null;
        var sub = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Back in stock popup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: LIST_ID } } }
          }
        };
        return post('subscriptions', sub).catch(function () { return null; });
      })
      .then(function () {
        dialog.querySelector('.wf-bis-form').hidden = true;
        var ok = dialog.querySelector('.wf-bis-success');
        ok.hidden = false;
        ok.querySelector('.wf-bis-done').focus();
        input.value = '';
      })
      .catch(function () {
        msg.textContent = TXT.error;
        msg.classList.add('is-error');
      })
      .then(function () {
        submit.disabled = false;
        submit.textContent = TXT.button;
      });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.wf-bis-btn, .wf-bis-open, .wf-bis-alt') : null;
    if (!t) return;
    e.preventDefault();
    var root = t.closest('[data-wf-bis]');
    if (!root && t.dataset.wfBisSection) {
      root = roots().filter(function (r) { return r.dataset.section === t.dataset.wfBisSection; })[0];
    }
    if (!root) return;
    openDialog(stateFor(root), t, root);
  });

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var d = (evt && evt.data) || {};
        if (d.sectionId) lastVariant[d.sectionId] = d.variant || null;
        queueSync();
      });
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'attributes') {
            var tg = r.target;
            if ((tg.id && tg.id.indexOf('ProductSubmitButton-') === 0) || (tg.name === 'id' && tg.tagName === 'INPUT')) { queueSync(); return; }
          } else if (r.type === 'childList') {
            queueSync(); return;
          }
        }
      }).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['disabled', 'value'], childList: true });
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') queueSync();
    }, true);
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
